
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register-buyer",
      function () {
        return require("private-next-pages/register-buyer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register-buyer"])
      });
    }
  